import { queryOptions } from "@tanstack/react-query";
import type {
  InvitationListData,
  InvitationListResponse,
} from "@/app/invitations/types";
import { getCoordinatorApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { invitationKeys } from "./query-keys";

const fetchProjectInvitations = async (
  scope: OrgProjectScope
): Promise<InvitationListData> => {
  const client = getCoordinatorApi(scope);
  const { data } = await client.get<InvitationListResponse>("/invitations");
  return data.data;
};

export const projectInvitationsQueryOptions = (
  organizationId: string,
  projectId: string
) =>
  queryOptions<InvitationListData>({
    queryKey: invitationKeys.list({
      scope: { organizationId, projectId },
    }),
    queryFn: () => fetchProjectInvitations({ organizationId, projectId }),
  });
